import makeRequest from '@jg/http-client';
import config from '../config';

type Charity = {
  charityId: number;
  charityName: string;
};

export type FrpData = {
  eventGivingGroupId: number;
  pageGuid: string;
  createdDate: string;
  name: string;
  photo: string;
  eventId: number;
  currencyCode: string;
  status: string;
  owner: {
    firstName: string;
    userGuid: string;
    lastName: string;
  };
  campaignGuid: string | null;
  charityIds: string[];
  charities: Charity[];
  shortName: string;
  targetAmount: number;
  raisedAmount: number;
  raisedOfflineAmount: number;
  raisedGiftAidAmount: number;
  event: {
    eventId: number;
    eventName: string;
    startDate: string;
    completionDate: string;
    isCreatedByUser: boolean;
    isPublic: boolean;
    eventCategoryName: string;
    eventTypeName: string;
  };
  story: string;
  statementWhat: null | string;
  statementWhy: null | string;
  attribution: string;
  inMemoryPerson: string | null;
};

export default async (frpId: string): Promise<FrpData | undefined> => {
  try {
    const response = await makeRequest(`${config.frpAPIv2}/${frpId}`, {
      credentials: 'omit',
    });
    const json = await response.json();
    return json;
  } catch (error) {
    return undefined;
  }
};
